import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

export const appKeys = {
  currentUser: () => [QueryKeyEnum.CURRENT_USER] as const,
  jainIntegration: () => [QueryKeyEnum.JAIN_INTEGRATION] as const,
  mediaIntegration: () => [QueryKeyEnum.MEDIA_INTEGRATION] as const,
  ping: () => [QueryKeyEnum.PING] as const,
};

export const attemptKeys = {
  details: (attemptId: string | undefined) => [QueryKeyEnum.ATTEMPT_DETAILS, attemptId] as const,
  exam: (attemptId: string | undefined) => [QueryKeyEnum.EXAM, attemptId] as const,
  list: <Params>(params: Params) => [QueryKeyEnum.LIST_ATTEMPTS, params] as const,
  lists: () => [QueryKeyEnum.LIST_ATTEMPTS] as const,
  timeline: (attemptId: string) => [QueryKeyEnum.ATTEMPT_TIMELINE, attemptId] as const,
  view: (attemptId: string | undefined) => [QueryKeyEnum.ATTEMPT, attemptId] as const,
};

export const dictionaryKeys = {
  categories: () => [QueryKeyEnum.LIST_CATEGORIES] as const,
  categoryList: (activeOnly: boolean) => [QueryKeyEnum.LIST_CATEGORIES, { activeOnly }] as const,
  positionList: (selectableOnly: boolean) =>
    [QueryKeyEnum.LIST_POSITIONS, { selectableOnly }] as const,
  positions: () => [QueryKeyEnum.LIST_POSITIONS] as const,
  procedureNames: (search: string) => [QueryKeyEnum.LIST_PROCEDURE_NAMES, { search }] as const,
  tagList: (activeOnly: boolean, search: string) =>
    [QueryKeyEnum.LIST_TAGS, { activeOnly, search }] as const,
  tags: () => [QueryKeyEnum.LIST_TAGS] as const,
};

export const questionKeys = {
  bulkPreview: <Request>(request: Request) => [QueryKeyEnum.BULK_PREVIEW, request] as const,
  detail: (questionId: string | undefined) => [QueryKeyEnum.QUESTION_DETAIL, questionId] as const,
  details: () => [QueryKeyEnum.QUESTION_DETAIL] as const,
  focusIds: () => [QueryKeyEnum.FOCUS_QUESTION_IDS] as const,
  focusIdsPage: <Params>(sessionId: string, params: Params) =>
    [QueryKeyEnum.FOCUS_QUESTION_IDS, sessionId, params] as const,
  histories: () => [QueryKeyEnum.QUESTION_HISTORY] as const,
  history: (questionId: string | undefined) => [QueryKeyEnum.QUESTION_HISTORY, questionId] as const,
  impact: <Plans>(plans: Plans) => [QueryKeyEnum.QUESTION_IMPACT, plans] as const,
  list: <Params>(params: Params) => [QueryKeyEnum.LIST_QUESTIONS, params] as const,
  lists: () => [QueryKeyEnum.LIST_QUESTIONS] as const,
  version: (questionId: string, versionId: null | string) =>
    [QueryKeyEnum.QUESTION_VERSION, questionId, versionId] as const,
  versions: (questionId: string) => [QueryKeyEnum.QUESTION_VERSION, questionId] as const,
};

export const statisticsKeys = {
  all: () => [QueryKeyEnum.QUESTION_STATISTICS] as const,
  categories: <Params>(params: Params) =>
    [QueryKeyEnum.QUESTION_STATISTICS, 'categories', params] as const,
  question: <Params>(questionId: string | undefined, params: Params) =>
    [QueryKeyEnum.QUESTION_STATISTICS, 'question', questionId, params] as const,
  ranking: <Params>(params: Params) =>
    [QueryKeyEnum.QUESTION_STATISTICS, 'ranking', params] as const,
};

export const surveyKeys = {
  detail: (surveyId: string | undefined) => [QueryKeyEnum.SURVEY_DETAIL, surveyId] as const,
  history: (surveyId: string | undefined) => [QueryKeyEnum.SURVEY_HISTORY, surveyId] as const,
  list: <Params>(params: Params) => [QueryKeyEnum.LIST_SURVEYS, params] as const,
  lists: () => [QueryKeyEnum.LIST_SURVEYS] as const,
  preview: (
    surveyId: string | undefined,
    locale: string | undefined,
    positionCode: string | undefined,
  ) => [QueryKeyEnum.SURVEY_PREVIEW, surveyId, locale, positionCode] as const,
};

export const surveyResponseKeys = {
  details: (responseId: string | undefined) =>
    [QueryKeyEnum.SURVEY_RESPONSE_DETAILS, responseId] as const,
  list: <Params>(params: Params) => [QueryKeyEnum.LIST_SURVEY_RESPONSES, params] as const,
  lists: () => [QueryKeyEnum.LIST_SURVEY_RESPONSES] as const,
  view: (responseId: string | undefined) => [QueryKeyEnum.SURVEY_RESPONSE, responseId] as const,
};

export const testKeys = {
  detail: (testId: string | undefined) => [QueryKeyEnum.TEST_DETAIL, testId] as const,
  history: (testId: string | undefined) => [QueryKeyEnum.TEST_HISTORY, testId] as const,
  list: <Params>(params: Params) => [QueryKeyEnum.LIST_TESTS, params] as const,
  lists: () => [QueryKeyEnum.LIST_TESTS] as const,
  names: () => [QueryKeyEnum.LIST_TESTS, 'names'] as const,
  poolPreview: <Request>(request: Request) => [QueryKeyEnum.TEST_POOL_PREVIEW, request] as const,
  sample: (
    testId: string | undefined,
    locale: string | undefined,
    positionCode: string | undefined,
  ) => [QueryKeyEnum.TEST_SAMPLE, testId, locale, positionCode] as const,
};

export const testPersonKeys = {
  all: () => [QueryKeyEnum.TEST_PERSON] as const,
  standing: <Query>(query: Query) => [QueryKeyEnum.TEST_PERSON, query] as const,
};
